'use client'

import React, { useState, useEffect, useRef } from "react";
import { Input, Pagination } from "antd";
import SelectZone from "./SelectZone";
import { useGlobalContext } from "../../context/provider";
import CardEbook from "../../Card/Card";
import { AxiosGetData } from "../../context/axiosfunction"

const FilterTablet = ({ selectdata, ebook, search, tag, setebook, catetypeBook }) => {

  const { screen, API, headers, privateKey } = useGlobalContext()
  const [filter, setFilter] = useState(false)
  const [TextSearch, setTextSearch] = useState('')
  const [page, setPage] = useState(1)
  const [filterSituation, setFilterSituation] = useState({})
  const [textquery, setTextquery] = useState('')
  const pageRef = useRef(page);
  const [hasMore, setHasMore] = useState(true);

  const [loading, setLoading] = useState(false)
  const sentinelRef = useRef(null);
  const [selectCate, setSelectCate] = useState({ book_type: 'all', book_cate: 'all' })
  const queryRef = useRef('');
  const normalize = (v) => (v === 'all' || v === '' || v === null || v === undefined ? undefined : v);

  useEffect(() => { queryRef.current = TextSearch; }, [TextSearch]);
  useEffect(() => { pageRef.current = page; }, [page]);
  // console.log(catetypeBook);

  useEffect(() => {
    if (!filterSituation) return;

    // สร้างสำเนาที่ล้างค่าแล้ว
    const cleaned = {
      book_type: normalize(filterSituation.book_type),
      book_cate: normalize(filterSituation.book_cate),
      form: normalize(filterSituation.form),
      tag: normalize(filterSituation.tag),
      sort: normalize(filterSituation.sort),
      partner: normalize(filterSituation.partner),
      search:
        typeof filterSituation.search === 'string'
          ? (filterSituation.search.trim() || undefined)
          : undefined,
      status: normalize(filterSituation.status),
      lengthPrice: Array.isArray(filterSituation.lengthPrice)
        ? filterSituation.lengthPrice
        : undefined,
    };

    const urlParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : new URLSearchParams();
    const hasUrlQuery = urlParams.toString().length > 0 || (typeof search === 'string' && search.trim().length > 0) || (typeof tag === 'string' && tag.trim().length > 0);

    // ถ้าไม่มีค่าอะไรเลยก็ออก
    const hasFilter =
      hasUrlQuery ||
      cleaned.book_type !== undefined ||
      cleaned.form !== undefined ||
      cleaned.tag !== undefined ||
      cleaned.book_cate !== undefined ||
      cleaned.partner !== undefined ||
      cleaned.search !== undefined ||
      cleaned.status !== undefined ||
      cleaned.sort !== undefined ||
      (Array.isArray(cleaned.lengthPrice) &&
        (Number.isFinite(cleaned.lengthPrice[0]) ||
          Number.isFinite(cleaned.lengthPrice[1])));

    if (!hasFilter) {
      // เคส "ล้างทุกอย่าง" → โหลดหน้า 1 แบบไม่มี query
      (async () => {
        try {
          setLoading(true);
          setPage(1);
          pageRef.current = 1;
          setHasMore(true)
          const GetBook = await AxiosGetData(API, `/api/all_ebook?page=1`, headers, privateKey);
          setebook(GetBook);
          setTextSearch('');        // << สำคัญ: ทำให้ queryRef.current กลายเป็นสตริงว่าง
        } finally {
          setLoading(false);
        }
      })();
      return;
    }

    const qs = new URLSearchParams(urlParams);

    if (urlParams.has('text') && !qs.has('search')) {
      qs.set('search', urlParams.get('text'));
      qs.delete('text');
    }

    if (cleaned.tag !== undefined) {
      qs.set('tag', String(cleaned.tag));
    } else if (filterSituation.tag === null || filterSituation.tag === 'all') {
      qs.delete('tag');
    }

    if (cleaned.book_type !== undefined) {
      qs.set('bkt', String(cleaned.book_type));
    } else if (filterSituation.book_type === null || filterSituation.book_type === 'all') {
      qs.delete('bkt');
    }

    if (cleaned.book_cate !== undefined) {
      qs.set('cate', String(cleaned.book_cate));
    } else if (filterSituation.book_cate === null || filterSituation.book_cate === 'all') {
      qs.delete('cate');
    }

    if (Array.isArray(cleaned.lengthPrice)) {
      const [min, max] = cleaned.lengthPrice;
      if (Number.isFinite(min)) qs.set('priceMin', String(min));
      if (Number.isFinite(max)) qs.set('priceMax', String(max));
    } else if (filterSituation.lengthPrice === null) {
      qs.delete('priceMin');
      qs.delete('priceMax');
    }

    if (cleaned.partner !== undefined) {
      qs.set('partner', String(cleaned.partner));
    } else if (filterSituation.partner === null || filterSituation.partner === '') {
      qs.delete('partner');
    }

    if (cleaned.search !== undefined) {
      qs.set('search', cleaned.search);
    } else if (filterSituation.search === null || filterSituation.search === '') {
      qs.delete('search');
    }

    if (cleaned.status !== undefined) {
      qs.set('status', String(cleaned.status));
    } else if (filterSituation.status === null || filterSituation.status === '') {
      qs.delete('status');
    }

    if (cleaned.form !== undefined) {
      qs.set('form', String(cleaned.form));
    } else if (filterSituation.form === null || filterSituation.form === '') {
      qs.delete('form');
    }

    if (cleaned.sort !== undefined) {
      qs.set('sort', String(cleaned.sort));
    } else if (filterSituation.sort === null || filterSituation.sort === '') {
      qs.delete('sort');
    }

    if (search && typeof search === 'string' && search.trim() !== '' && !qs.has('search')) {
      qs.set('search', search.trim());
    }

    if (tag && typeof tag === 'string' && tag.trim() !== '' && !qs.has('tag')) {
      qs.set('tag', tag.trim());
    }

    const queryString = qs.toString();

    (async () => {
      try {
        setLoading(true);
        setPage(1);
        pageRef.current = 1;

        const GetBook = await AxiosGetData(
          API,
          `/api/all_ebook?page=1${queryString ? '&' + queryString : ''}`,
          headers,
          privateKey
        );
        setHasMore(true);   // reset ว่ายังโหลดได้
        setebook(GetBook);
        setTextSearch(queryString);   // << ถ้าค่าว่าง จะกลายเป็น '' ได้จริง
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    })();
  }, [filterSituation, search, tag]);


  useEffect(() => {
    if (!sentinelRef.current) return;
    const io = new IntersectionObserver(async (entries) => {
      const [e] = entries;
      if (e.isIntersecting && hasMore && !loading) {
        const next = pageRef.current + 1;
        const query = queryRef.current;
        try {
          setLoading(true);
          const GetBook = await AxiosGetData(
            API,
            `/api/all_ebook?page=${next}${query !== '' ? '&' + query : ''}`,
            headers,
            privateKey
          );

          if (!GetBook || GetBook.length === 0) {
            setHasMore(false);
            setLoading(false);
            return;
          }

          setTimeout(() => {
            setebook(prev => [...prev, ...GetBook]);
            setLoading(false);
          }, [500])

          setPage(prev => {
            const np = prev + 1;
            pageRef.current = np;
            return np;
          });
        } catch (error) {
          console.error(error);
        }
      }
    }, {
      root: null,
      rootMargin: "300px",
      threshold: 0.01
    });

    io.observe(sentinelRef.current);
    return () => io.disconnect();
  }, [hasMore, loading]);


  return (
    <div className="grid grid-cols-12 self-start w-[100%] gap-[24px] mb-[1em]">

      <div className="flex flex-col  px-[7%] md:px-[8%] col-span-12 mt-[1.5em]">
        {!filter &&
          <Input.Search placeholder='ชื่ออีบุ๊ค' onSearch={(e) => setFilterSituation(prev => ({
            ...prev,
            search: e,
            lengthPrice: null,
            form: null,
            partner: null,
            status: null,
            sort: null,
            // book_type:getType ===''? null : getType,
            // book_cate:getCate ===''? null : getCate
          }))} />
        }
        <div className="flex justify-between items-center mt-4">
          <h1 className="text-[18px] font-medium">ค้นหาอีบุ๊ก</h1>
          <button onClick={() => setFilter((prev) => !prev)} className='bg-[#5298EC] text-white text-[14px] xl:text-[16px] w-[120px] h-[35px] rounded-[4px] ml-[1em]'>ค้นหาแบบละเอียด</button>
        </div>
      </div>
      {/* <div className="col-span-12 px-[7%] md:px-[8%] "><Input onChange={(e)=>setTextSearch(e.target.value)} className="h-[40px] " /></div> */}
      <div className={` px-[7%] md:px-[8%] grid grid-cols-12 col-span-12 overflow-hidden gap-[16px] md:gap-[24px] transition-[max-height] duration-300 ease-in-out
                ${filter ? 'max-h-[650px] mb-[15px]' : 'max-h-0 '} `}>
        <SelectZone setFilterSituation={setFilterSituation} selectdata={selectdata} cate={catetypeBook} />
      </div>
      <div className='px-[24px] md:px-[8%] col-span-12  '>
        <h1 className='text-[24px] font-medium col-span-12'>ผลการค้นหา </h1>
        <div className="grid justify-center grid-cols-9 md:grid-cols-10 my-[1em] gap-[18px] ">
          {ebook.length > 0 ?
            <>
              {ebook.map((data) => (
                <div key={data.id} className='col-span-3 md:col-span-2'>
                  <CardEbook Ebookdata={data} type='SearchBook' />
                </div>
              ))}
            </>
            :
            <div className='col-span-12 flex justify-center items-center'>ไม่พบหนังสือที่ต้องการ</div>
          }
          <div ref={sentinelRef} style={{ height: 1 }} className="" />
          {loading && <img src='https://eve-image.eveebook.com/image.eveebook/mascot/loading.gif' className="col-span-9 md:col-span-10 w-[200px] mx-auto" alt="loading" />}
        </div>
      </div>
    </div>
  )
}

export default FilterTablet